// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper_2UX2v","icon":"Search_icon_2XJnp","container":"Search_container_2Nx1a","inputWrapper":"Search_inputWrapper_x-jF1","input":"Search_input_3aW6A"};